/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-06-11 20:34:41
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-06-11 21:12:07
 * @FilePath: /roboneo-web/src/components/roboneo/IPadTips/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect } from 'react';
import { setHeaderConfig, useCommonStore } from '@/store/useCommonStore';
import style from './index.module.scss';

export default function IPadTips() {
  const ua = navigator.userAgent.toLocaleLowerCase();
  const ipad = ua.includes('ipad');
  const macintosh = ua.includes('macintosh');
  const isIPad = ipad || (macintosh && navigator.maxTouchPoints > 1);
  const headerConfig = useCommonStore((state) => state.headerConfig);
  useEffect(() => {
    if (isIPad) {
      // 获取根元素
      const root = document.documentElement;
      // 修改CSS变量
      root.style.setProperty('--ipad-tips-height', '40px');
      setHeaderConfig({
        height: (headerConfig.height || 60) + 40,
      });
    }
  }, []);

  if (!isIPad) {
    return null;
  }
  return (
    <div className={style.ipad_tips_box}>
      本网站在iPad上功能有限，为了更好的体验，建议使用电脑访问哦～
    </div>
  );
}
